import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/shell/layout/layout';
import { authGuard } from 'app/core/guards/auth.guard';
import { guestGuard } from 'app/core/guards/guest.guard';
import { roleGuard } from 'app/core/guards/role.guard';

import { provideHttpClient } from '@angular/common/http';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('app/features/auth/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },

  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'inicio',
        loadComponent: () =>
          import('./features/home/pages/home/home.component').then(
            (m) => m.HomeComponent
          ),
      },
      {
        path: 'subastas',
        loadChildren: () =>
          import('./features/auctions/routes').then((m) => m.routes),
      },
      {
        path: 'crear-subastas',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import('./features/auctions/pages/create/crear-subastas').then(
            (m) => m.CreateAuctionsComponent
          ),
      },
      {
        path: 'lotes',
        loadChildren: () =>
          import('./features/lots/routes').then((m) => m.routes),
      },
      {
        path: 'participantes',
        loadChildren: () =>
          import('./features/participants/routes').then((m) => m.routes),
      },
      {
        path: 'rescates',
        canActivate: [roleGuard(['colecturia', 'colecturía'])],
        loadChildren: () =>
          import('./features/rescues/routes').then((m) => m.routes),
      },
      {
        path: 'payments',
        canActivate: [roleGuard(['tecnico', 'técnico'])],
        loadChildren: () =>
          import('./features/payments/routes').then((m) => m.routes),
      },      
      {
        path: 'informacion-oficial',
        canActivate: [roleGuard(['lectura'])],
        loadComponent: () =>
          import('./features/official-info/pages/list/official-info.component').then(
            (m) => m.OfficialInfoComponent
          ),
      },
      {
        path: 'crear',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import('./features/lots/pages/create/creacion-lotes.component').then(
            (m) => m.CreateLotsComponent
          ),
        providers: [provideHttpClient()],
      },
      {
        path: 'crear-manual',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import(
            './features/lots/pages/create-manual/creacion-lotes-manual-component'
          ).then((m) => m.ManualLotCreationComponent),
      },
      {
        path: 'infolote/:id',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import(
            './features/auctions/pages/addremove-info/addremove-info.component'
          ).then((m) => m.AddRemoveInfoComponent),
      },
      {
        path: 'editar-subasta/:id',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import('./features/auctions/pages/edit/editar-subasta').then(
            (m) => m.EditAuctionComponent
          ),
      },
      {
        path: 'verSubasta/:id',
        loadComponent: () =>
          import('./features/auctions/pages/view/ver-subasta').then(
            (m) => m.ViewAuctionComponent
          ),
      },
      {
        path: 'completarinfolote/:id',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import(
            './features/lots/pages/create-manual/creacion-lotes-manual-component'
          ).then((m) => m.ManualLotCreationComponent),
      },
      {
        path: 'editarinfolote/:id',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import('./features/lots/pages/edit/editar-lote.component').then(
            (m) => m.EditLotComponent
          ),
      },
      {
        path: 'verLote/:id',
        loadComponent: () =>
          import('./features/lots/pages/view/ver-lote').then(
            (m) => m.ViewLotComponent
          ),
      },
      {
        path: 'realizar-rescate/:id',
        canActivate: [roleGuard(['colecturia', 'colecturía','lectura'])],
        loadComponent: () =>
          import('./features/rescues/pages/create-rescue/create-rescue.component').then(
            (m) => m.CreateRescueComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
